import * as S from './Divider.styles';

type SpacingType =
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11';

type DividerProps = {
  variant: 'none' | 'neutral' | 'secondary-1' | 'warning' | 'info' | 'success';
  modifier: 'regular' | 'weak' | 'inverted';
  margin?:
    | SpacingType
    | {
        top?: SpacingType;
        left?: SpacingType;
        right?: SpacingType;
        bottom?: SpacingType;
      }
    | string;
  height?: string;
};

const defaultProps = {
  variant: 'neutral',
  modifier: 'weak',
  margin: 'none',
  height: '1px',
};
const Divider = (props: DividerProps) => {
  const { variant, modifier, margin, height } = props;
  return (
    <S.Card
      variant={variant}
      modifier={modifier}
      width='100%'
      height={height}
      margin={margin}
    ></S.Card>
  );
};

Divider.defaultProps = defaultProps;
export default Divider;
